import { render, staticRenderFns } from "./RegistrarEmpleado.vue?vue&type=template&id=0cf37f63&scoped=true&"
import script from "./RegistrarEmpleado.vue?vue&type=script&lang=js&"
export * from "./RegistrarEmpleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf37f63",
  null
  
)

export default component.exports